module.exports = __webpack_public_path__ + "static/img/ad2.f044a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ad2.png
// module id = 6tO0
// module chunks = 30